import React, { useEffect, useRef } from 'react';

import { ICompanyChoiceOption } from 'services/authorization/types';

import Button from 'components/Button';

import useStyles from './companyChoiceStyles';

interface IProps {
  companies: ICompanyChoiceOption[];
  disabled?: boolean;
  onSelect: (company: ICompanyChoiceOption) => void;
  onBack: () => void;
}

const CompanyChoiceList: React.FC<IProps> = ({ companies, disabled, onSelect, onBack }) => {
  const classes = useStyles();
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <div className={classes.root}>
      <h2 ref={headingRef} tabIndex={-1} className={classes.heading}>
        Choose a company
      </h2>
      <p className={classes.hint}>
        This email address has an account in more than one company. Select the one you want to sign in to.
      </p>
      <ul className={classes.list}>
        {companies.map(company => (
          <li key={company.accountId}>
            <Button
              fullWidth
              disabled={disabled}
              onClick={() => {
                onSelect(company);
              }}
              label={company.companyName?.trim() ? company.companyName : `Account ${company.accountId}`}
            />
          </li>
        ))}
      </ul>
      <Button variant="text" label="Back to sign in" disabled={disabled} onClick={onBack} />
    </div>
  );
};

export default CompanyChoiceList;
